/**
 * GA4 全局埋点组件（在 App 根挂载一次）。
 *
 * GaPageViews：路由变化（含首屏）发 page_view。预渲染首屏同样走这里——
 * gtag config 关闭了自动 page_view，预渲染页与 SPA 导航的上报口径统一。
 * billing 路由态弹窗（state.background）的导航也会触发一次 page_view，
 * 视作虚拟浏览，符合「用户看到了定价/订阅内容」的度量意图。
 *
 * GaSignUp：登录态从无到有时，若账号 createdAt 在 2 分钟内视为新注册
 * （区别于老用户登录），发一次 sign_up。模块级 flag 保证整个页面生命周期
 * 只发一次（StrictMode 双执行 / 多组件实例均不重复）。
 */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useUser } from "@clerk/clerk-react";
import { trackEvent, trackPageView } from "../lib/analytics";

export function GaPageViews() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    trackPageView(pathname + search);
  }, [pathname, search]);
  return null;
}

let signUpFired = false;

export function GaSignUp() {
  const { user, isSignedIn } = useUser();
  useEffect(() => {
    if (signUpFired || !isSignedIn || !user?.createdAt) return;
    if (Date.now() - user.createdAt.getTime() > 2 * 60 * 1000) return;
    signUpFired = true;
    trackEvent("sign_up", {
      method: user.externalAccounts[0]?.provider ?? "unknown",
    });
  }, [isSignedIn, user]);
  return null;
}
